import { TeamRoutes} from 'typings/enums';

/**
 * Cycle configuration
    * https://tp.prestaging.underpaid.com/configuration/cycle?cycleId=918&view=budget
    *  BudgetView
        * https://tp.prestaging.underpaid.com/configuration/cycle?cycleId=918&view=budget
        * https://tp.prestaging.underpaid.com/configuration/cycle?cycleId=918&view=budget&budgetType=merit
    * Eligibility
        * https://tp.prestaging.underpaid.com/configuration/cycle?cycleId=918&view=budget&rulesPanel=true&rulesTab=eligibilityrule
        * https://tp.prestaging.underpaid.com/configuration/cycle?cycleId=918&view=budget&rulesPanel=true&rulesTab=prorationrule
    * Workflow
        *  https://tp.prestaging.underpaid.com/configuration/cycle?cycleId=918&view=workflow&workflowType=hrroles
        *  https://tp.prestaging.underpaid.com/configuration/cycle?cycleId=918&view=workflow&workflowType=workflowconfiguration
    * cycleNotOpen
        *  /cycleNotOpen
 * CycleSettings
    * https://tp.prestaging.underpaid.com/mobx/cycles/cycleSettings?cycleId=918
 * GlobalConfiguration
    * https://tp.prestaging.underpaid.com/configuration/global?view=HRBP
    * https://tp.prestaging.underpaid.com/configuration/global?view=Employee
    * https://tp.prestaging.underpaid.com/configuration/global?view=DataSummary
 * ManagerView
    * https://tp.prestaging.underpaid.com/cycles/managers/managerview?cycleId=918&mid=10013&list=open&reports=directs&sidePanel=false
    * https://tp.prestaging.underpaid.com/cycles/managers/managerview?cycleId=918&mid=10013&list=open&reports=all&sidePanel=false
 * ChangeHistory
    * https://tp.prestaging.underpaid.com/cycles/changehistory?cycleId=918&mid=10013&list=open&reports=all
 * OrgChart
    * https://tp.prestaging.underpaid.com/cycles/managers/managerview/orgchart?mid=10013
 */


export const getPageUrlSearchTerms = (pathName: string, queryString: string): string => {
    let pathSearchTerm = '';

    if (pathName === TeamRoutes.Support
        || pathName === TeamRoutes.AccessDenied
        || pathName === TeamRoutes.Error
        || pathName === TeamRoutes.Diagnostics
        || pathName === TeamRoutes.InvalidAccount
        || pathName === TeamRoutes.Logout
        || pathName === TeamRoutes.TeamDown) {
        return '';
    }

    const queryStringSearchTerm = parseQueryString(queryString);

    if (pathName === TeamRoutes.CycleSettings) {
        pathSearchTerm = 'cycle settings';
    }

    if (pathName === TeamRoutes.CycleNotOpenManagerView) {
        pathSearchTerm = 'cycle';
    }

    if (pathName === TeamRoutes.ChangeHistory) {
        pathSearchTerm = 'change history';
    }

    if (pathName === TeamRoutes.Decision) {
        pathSearchTerm = 'manager decisions';
    }

    if (pathName.indexOf('orgChart') > 0) {
        pathSearchTerm = 'org chart';
    }

    return  pathSearchTerm || queryStringSearchTerm ? (`${pathSearchTerm} ${queryStringSearchTerm}`).trim() : '';
};


export const parseQueryString = (queryString: string): string => {

    // query string params to ignore
    // cycleId=980
    // mid=10013
    // empId=10046
    // list=open
    // reports=directs
    // sidePanel=false
    // rulesPanel=true

    let parseQueryString = queryString;
    const results: string[] = [];
    if(queryString.startsWith('?')) {
        parseQueryString = queryString.substring(1);
    }

    const allQueryParams = parseQueryString.split('&');
    allQueryParams.forEach(queryParam => {
        const queryParamData = queryParam.split('=');
        const queryParamName = queryParamData[0];
        const queryParamValue = queryParamData[1];

        if(!ignoredQueryParams.has(queryParamName)) {
            queryParamsSearchTerm.has(queryParamValue)
                ? results.push(queryParamsSearchTerm.get(queryParamValue) || '')
                : results.push(queryParamValue);
        }
    });
    return results.length ? results.join(' '): '';
};

const ignoredQueryParams: Map<string, string> = new Map([
    ['cycleId', 'cycleId'],
    ['mid', 'mid'],
    ['empId', 'empId'],
    ['list', 'list'],
    ['reports', 'reports'],
    ['sidePanel','sidePanel'],
    ['rulesPanel','rulesPanel'],
    ['budgetType', 'budgetType'],
    ['workflowType', 'workflowType']
]);

const queryParamsSearchTerm: Map<string, string> = new Map([
    ['eligibilityrule', 'eligibility rule'],
    ['prorationrule', 'proration rule'],
    ['DataSummary', 'data summary'],
    ['HRBP', 'hr business partner']
]);